import './PartReCategorizationComponent.scss';
import React from "react";
import {ExpandMore} from "@mui/icons-material";
import {ButtonBase, Chip, Tooltip} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {categoryNameCutoffEllipsisLength, doEllipsisCutoff} from "../../utils/str.utils.ts";
import {DEFAULT_CATEGORY_COL_WIDTH} from "../../stores/ProfileStore.tsx";

type Props = {
    cats: string[] | false
    handleOpenSearch: (event: React.MouseEvent<HTMLButtonElement>) => void
    selectedL1Category: string | undefined,
    colWidth?: number,
}
export const PartReCategorizationComponent: React.FC<Props> = (
    {cats, handleOpenSearch, selectedL1Category, colWidth}) => {
    const catsIsUncategorized = cats === false || cats.every(c => c === UNCATEGORIZED_VALUE); // | cats.length === 0
    const isNoCategory = cats !== false && cats.length === 0;
    const maxLabelLength = categoryNameCutoffEllipsisLength(colWidth ?? DEFAULT_CATEGORY_COL_WIDTH)

    return <div className="part-recat-component">
        <ButtonBase onClick={handleOpenSearch}>
            {isNoCategory
                ? <Chip
                    className="category-chip"
                    variant="outlined"
                    color="primary"
                    size="small"
                    deleteIcon={<ExpandMore/>}
                    onDelete={handleOpenSearch}
                    label="Change all categories for supplier"
                />
                : catsIsUncategorized
                    ? <Chip
                        className="category-chip"
                        variant="outlined"
                        color="primary"
                        size="small"
                        deleteIcon={<ExpandMore/>}
                        onDelete={handleOpenSearch}
                        label={UNCATEGORIZED_LABEL}
                    />
                    : (cats as string[]).map((c, i) => {
                        const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
                        const [s, cutoff] = doEllipsisCutoff(categoryLabel, maxLabelLength);

                        const chip = <>
                            <Chip
                                className="category-chip"
                                variant="outlined"
                                color={selectedL1Category === c ? "secondary" : "default"}
                                size="small"
                                deleteIcon={(i === (cats as string[]).length - 1) ? <ExpandMore/> : undefined}
                                onDelete={(i === (cats as string[]).length - 1) ? handleOpenSearch : undefined}
                                label={s}
                            />
                            {(i < (cats as string[]).length - 1) && <NavigateNextIcon fontSize="small"/>}
                        </>
                        if (cutoff) {
                            return <Tooltip key={i} title={categoryLabel}><span>{chip}</span></Tooltip>
                        } else {
                            return <React.Fragment key={i}>{chip}</React.Fragment>;
                        }
                    })
            }
        </ButtonBase>
    </div>;
}
